export const cifTz = ["301 201","<defs><path id='a' d='M.5.5h300v200H.5z'/><path id='c' d='M.5.5h300v200H.5z'/></defs><g fill='none' fill-rule='evenodd'><path fill='#1EB53A' fill-rule='nonzero' d='M.5.5h300l-300 200'/><path fill='#00A3DD' fill-rule='nonzero' d='M.5 200.5h300V.5'/><mask id='b' fill='#fff'><use xlink:href='#a'/></mask><path d='M.5 200.5l300-200' stroke='#FCD116' stroke-width='70' mask='url(#b)'/><g><mask id='d' fill='#fff'><use xlink:href='#c'/></mask><path d='M.5 200.5l300-200' stroke='#000' stroke-width='50' mask='url(#d)'/></g></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-tz.js
// module id = null
// module chunks = 